import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AcessoService } from '../services/acesso.service';

/**
 * Guard para proteger rotas com base em permissões de módulos.
 *
 * Uso:
 * ```typescript
 * {
 *   path: 'alguma-rota',
 *   component: AlgumComponent,
 *   canActivate: [ModuloGuard],
 *   data: { modulo: 'nome-do-modulo' }
 * }
 * ```
 *
 * Se o usuário não tiver permissão, ele será redirecionado para o dashboard.
 */
@Injectable({
  providedIn: 'root'
})
export class ModuloGuard implements CanActivate {

  constructor(
    private acessoService: AcessoService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    // Obtém o nome do módulo/rota da configuração da rota
    const modulo = route.data['modulo'] as string;

    // Se não houver módulo especificado, permite acesso
    if (!modulo) {
      console.warn('ModuloGuard: Nenhum módulo especificado na rota. Permitindo acesso.');
      return true;
    }

    // Verifica se o usuário tem acesso ao módulo usando a rota
    const temAcesso = this.acessoService.temAcessoRota(modulo);

    if (temAcesso) {
      return true;
    } else {
      console.warn(`ModuloGuard: Acesso negado à rota '${modulo}'. Redirecionando para o dashboard.`);

      // Redireciona para o dashboard
      this.router.navigate(['/dashboard']);
      return false;
    }
  }
}
